import { Routes } from '@angular/router';
import { ConnectionPage } from './pages/connection/connection-page';
import { DisplayPage } from './pages/display/display-page';
import { ConnectedPage } from './pages/connected/connected-page';
import { ScenicDisplayPage } from './pages/scenic-display/scenic-display-page';
import { CoachingDisplayPage } from './pages/coaching-display/coaching-display-page';
import { DisconnectedPage } from './pages/disconnected-page/disconnected-page';
import { userGuard } from './user-guard';

export const routes: Routes = [
  {
    path: '',
    component: ConnectionPage,
  },
  { path: 'connected', component: ConnectedPage, canActivate: [userGuard] },
  { path: 'disconnected', component: DisconnectedPage, canActivate: [userGuard] },
  {
    path: 'display',
    component: DisplayPage,
    canActivate: [userGuard],
    children: [
      {
        path: 'scenic',
        component: ScenicDisplayPage,
      },
      {
        path: 'coaching',
        component: CoachingDisplayPage,
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
